const groupPrefix = createApiRoute(ApiModule.SUPPLIER, ApiAuthorization.EMPLOYEE)

export const apiSuppliersProducts = {
	fetchSupplierProducts: async (id: number): Promise<IApiResponseModel<IPriceListProductModel[]>> => {
		const { data, meta } = await apiCommon<IPriceListProduct[]>(`${groupPrefix}/${id}/products`, {
			method: 'GET',
		})

		return { data: data.map(d => PriceListProduct(d)), meta }
	},

	deleteSupplierProducts: async (id: number): Promise<void> => {
		await apiCommon<string>(`${groupPrefix}/${id}/products`, {
			method: 'DELETE',
		})
	},
}
